<section class="stop-schedule-dialog">
    <div class="title">
        <morva-icons icon="close" (click)="closeDialog(false)"></morva-icons>
        <span *ngIf="mode === 'schedule'">
            غیرفعال کردن زمانبندی
        </span>
      <span *ngIf="mode === 'manual'">
            غیرفعال کردن به‌روزرسانی
        </span>
    </div>
    <div class="content me-0">
        <span *ngIf="mode === 'schedule'">
            آیااز غیر فعال کردن"<span>{{scheduleTitle}}</span>" اطمینان دارید؟
        </span>

      <span *ngIf="mode === 'manual'">
            آیااز غیر فعال کردن"<span>به‌روزرسانی</span>" اطمینان دارید؟
        </span>

    </div>
    <div></div>
    <div class="button-group mt-auto">
        <button
            nbButton
            (click)="closeDialog(false)">

            انصراف

        </button>

        <button
            nbButton
            [nbSpinner]="submitting"
            [ngClass]=""
            (click)="closeDialog(true)">

            تایید

        </button>
    </div>

  </section>
